import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blogHeader: {},
  isLoading: false,
  error: null,
  isError: false,
  openSubscribeModal: false,
  createSubscribeDetails: {
    isLoading: false,
    isError: false,
    error: null,
    data: {},
    isSuccess: false,
  },
};

export const blogHeaderRedux = createSlice({
  name: "blogHeaderRedux",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },

    setBlogHeaderState: (state, action) => {
      const newState = {
        ...state,
      };
      if (action?.payload?.key) {
        newState[action.payload.key] = action.payload.value;
      }
      return newState;
    },

    getBlogHeaderRequest: (state) => {
      const newState = {
        ...state,
        isLoading: true,
        blogHeader: {},
        isError: false,
        error: false,
      };

      return newState;
    },

    getBlogHeaderSuccess: (state, action) => {
      const newState = {
        ...state,
        blogHeader: action?.payload,
        isLoading: false,
        error: null,
        isError: false,
      };

      return newState;
    },

    getBlogHeaderFailure: (state, action) => {
      const newState = {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

      return newState;
    },

    // Create Subscribe
    createSubscribeReset: (state) => {
      const newState = {
        ...state,
        createSubscribeDetails: {
          isLoading: false,
          isError: false,
          error: null,
          data: {},
          isSuccess: false,
        },
      };

      return newState;
    },
    createSubscribeRequest: (state) => {
      const newState = {
        ...state,
        createSubscribeDetails: {
          isLoading: true,
          isError: false,
          error: null,
          data: {},
          isSuccess: false,
        },
      };

      return newState;
    },

    createSubscribeSuccess: (state, action) => {
      const newState = {
        ...state,
        createSubscribeDetails: {
          isLoading: false,
          isError: false,
          error: null,
          data: action?.payload,
          isSuccess: true,
        },
      };

      return newState;
    },

    createSubscribeFailure: (state, action) => {
      const newState = {
        ...state,
        createSubscribeDetails: {
          isLoading: false,
          isError: true,
          error: action?.payload?.message || "Something went wrong.",
          isSuccess: false,
        },
      };

      return newState;
    },

    openSubscribeModal: (state) => {
      const newState = {
        ...state,
        openSubscribeModal: true,
      };
      return newState;
    },

    closeSubscribeModel: (state) => {
      const newState = {
        ...state,
        openSubscribeModal: false,
      };
      return newState;
    },
  },
});

export const {
  resetState,
  setBlogHeaderState,
  openSubscribeModal,
  closeSubscribeModel,

  getBlogHeaderRequest,
  getBlogHeaderSuccess,
  getBlogHeaderFailure,
  createSubscribeRequest,
  createSubscribeSuccess,
  createSubscribeFailure,
} = blogHeaderRedux.actions;

export default blogHeaderRedux.reducer;
